function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 11a3 3 0 100-6 3 3 0 000 6zM9 20c-2.21 0-4.085-1.929-2.889-3.786A6.994 6.994 0 0112 13a6.994 6.994 0 015.889 3.214C19.085 18.07 17.209 20 15 20H9z",
  fill: "#FF6C0E"
});

function SvgPickitUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "/img/pickit-user.svg";
export { SvgPickitUser as ReactComponent };